import React from "react";

import IconSvg from "components/IconSvg";
import Image from "components/Image";

type Props = {
  menuItemImage: string | undefined;
  altText?: string;
  category?: string;
};

const CartItemCard = ({ menuItemImage, altText, category }: Props) => {
  return (
    <>
      {menuItemImage ? (
        <div
          style={{ height: 64, minWidth: 64, width: 64 }}
          className="flex mr-lg md:mr-xl"
        >
          <Image
            className="flex-1"
            imageClass="object-contain"
            alt={altText || ""}
            src={menuItemImage}
            sizes={[64]}
          />
        </div>
      ) : (
        <IconSvg
          className="mr-lg md:mr-xl"
          height="64"
          width="64"
          filePath={`productTypes/${category?.toLowerCase?.() || "other"}.svg`}
        />
      )}
    </>
  );
};

export default CartItemCard;
